import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  AddMMPLUserDetails,
  getMMPLUsersList,
} from "../Actions/UserManagementAPI";
import { getShipnameList } from "../Actions/HelpersAPI";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
import axios from "axios";
import { toast } from "react-toastify";
import API from "../helpers/api";
import { getUsersList } from "../Actions/CommonAPI";

let searchData = {
  email: "",
  PageNumber: 1,
  PageSize: 25,
};
let userkey = JSON.parse(localStorage.getItem("currentUser"));
class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      isAdmin: false,
      ships: [],
      createdBy: "",
      chosenMailid: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.handleTeam = this.handleTeam.bind(this);
    this.removeTeam = this.removeTeam.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(getShipnameList());
    this.props.dispatch(getUsersList());
  }
  handleInputChange(e) {
    this.state.emailId = e.target.value;
    this.setState({});
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState({
        isAdmin: true,
      });
    } else {
      this.setState({
        isAdmin: false,
      });
    }
  }

  handleTeam(list, item) {
    this.setState(
      {
        chosenMailid: list.map((x) => x.userId),
      },
      () => {
        console.log(this.state.chosenMailid);
      }
    );
  }
  removeTeam(list, item) {
    console.log("list", list);
    console.log("item", item);
    this.setState(
      {
        chosenMailid: list.map((x) => x.userId),
      },
      () => {
        console.log(this.state.chosenMailid);
      }
    );
  }

  SubmitData() {
    const { dispatch } = this.props;
    let userinfo = {
      email: this.state.emailId,
      isAdmin: this.state.isAdmin,
      mmplShips: this.state.ships.toString(),
      createdBy: "",
    };
    if (this.state.emailId !== "") {
      let url2 = `${API.userExist}?Mail=${this.state.emailId}&Id=${0}`;
      axios
        .get(url2, {
          headers: {
            key: userkey.accessToken,
          },
        })
        .then((response) => {
          if (response.data === true) {
            let url = `${API.UserAPI}`;
            let teamsurl = `${API.CreateTeams}`;
            axios
              .post(url, userinfo, {
                headers: {
                  key: userkey.accessToken,
                },
              })
              .then((response) => {
                let teamsData = {
                  modifiedBy: userkey.email,
                  userId: response.data,
                  // teammateId: this.state.chosenMailid,
                  listOfTeammatesId: this.state.chosenMailid,
                  // userIds : [
                  //     this.state.chosenMailid,
                  //     response.data
                  // ]
                };
                if(response.data!="failed"){
                  toast.success("Added Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
               dispatch(getMMPLUsersList(searchData));
                this.hideSidePanel();
                dispatch({
                  type: "PostUserSuccess",
                  data: response.data,
                });

                axios
                  .put(teamsurl, teamsData, {
                    headers: {
                      key: userkey.accessToken,
                    },
                  })
                  .then((response) => {
                    console.log("res", response);
                  })
                  .catch((error) => {
                    console.log("error", error);
                  });
              })
              .catch((error) => {
                dispatch({
                  type: "PostUserFailure",
                  data: "error",
                });
              });
          } else if (response.data === false) {
            swal(
              "Error!",
              "User already exist. Please change the email",
              "warning"
            );
            this.setState({ emailId: "" });
          }
          dispatch({
            type: "getUserExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getUserExistListFailure",
            data: "error",
          });
        });
    } else {
      swal("Error!", "Email is mandatory", "warning");
    }
  }

  hideSidePanel = () => {
    this.props.history.push(`/Home/Management/User`);
  };

  onSelectChange(item) {
    this.state.ships = item;
    this.setState({});
  }

  onRemoveChange(item) {
    this.state.ships = item;
    this.setState({});
  }

  render() {
    const { ShipNameList, userData } = this.props;
    let ScreenWidth = window.innerWidth;
    console.log("width", ScreenWidth);
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card MM-card-header mt-2 mb-0"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Add User
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div className="col-lg-4">
                    <label className="form-label">Email Id</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="emailId"
                      placeholder="Email Id"
                      value={this.state.emailId}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className="col-lg-2">
                    <label className="form-label">Is Admin</label>
                    <br></br>
                    <input
                      type="checkbox"
                      name="isAdmin"
                      checked={this.state.isAdmin}
                      onChange={(e) => this.handleCheckBoxChange(e)}
                    ></input>
                  </div>
                  <div className={"col-lg-4"}>
                    <label className="form-label">Team</label>
                    <Multiselect
                      options={userData}
                      isObject={true}
                      style={{
                        option: {
                          "margin-right": 0,
                          display: "block",
                          "font-weight": "normal",
                        },
                        chips: { "background-color": "#1E3A8A" },
                      }}
                      onSelect={this.handleTeam}
                      onRemove={this.removeTeam}
                      displayValue="mail"
                      closeIcon="cancel"
                    />
                    {/* <select
                                            className="form-control"
                                            name="team"
                                            value={this.state.chosenMailid}
                                            onChange={(e) => this.handleTeam(e)}
                                        >
                                        <option value="">Select Team</option>
                                        {userData && userData.length > 0 && userData.map(user => (
                                                <option value={user.mail}>{user.mail}</option>
                                            ))}
                                        </select> */}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Ship Name</label>
                    <br></br>
                    <Multiselect
                      options={ShipNameList}
                      isObject={false}
                      style={{
                        option: {
                          "margin-right": 0,
                          display: "block",
                          "font-weight": "normal",
                        },
                        chips: { "background-color": "#1E3A8A" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      placeholder={
                        this.state.ships && this.state.ships.length
                          ? ""
                          : "Select"
                      }
                      closeIcon="cancel"
                    />
                  </div>
                </div>
              </div>
              <div className="row py-3">
                <div className="col-lg-12">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.SubmitData()}
                    >
                      {" "}
                      Submit{" "}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ShipNameList: state.UserManageReducer.ShipNameList,
    UsersList: state.UserManageReducer.UsersList,
    userData: state.MMPLDashboardReducer.userData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddUser)
);
